import { api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine } from '@/init/swagger';
import yup from '@/init/yup';
import {
  MOVING_MINUTE_VALUE_TYPES,
  STATION_ADVANCED_SEARCH_TYPES_TYPE,
  STATION_SORT_VALUE_TYPES,
} from '@/types/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType } from 'yup';

export type IsCalendarOr = Exclude<
  api_portalOfficeListing_requestSearchPortalOfficeListingsUseEngine['is_calendar_or'],
  undefined
>;

export const CalendarSchema = yup.object({
  date_start: yup.string(),
  date_end: yup.string(),
  weeks: yup.array(yup.number()),
  zone_start: yup.string(),
  zone_end: yup.string(),
});

export const SearchStationDetailSchema = yup.object({
  searchType: yup.string<STATION_ADVANCED_SEARCH_TYPES_TYPE>(),
  location: yup.object({
    pref_name: yup.string(),
    zipcode: yup.string(),
    address: yup.string(),
    longitude: yup.string(),
    latitude: yup.string(),
    km_radius: yup.number(),
    moving_minutes: yup.string<MOVING_MINUTE_VALUE_TYPES>(),
  }),
  partnerName: yup.string(),
  is_calendar_or: yup.number<IsCalendarOr>(),
  calendars: yup.array(CalendarSchema),
  calendar_filter_condition: yup.string(),
  sort: yup.string<STATION_SORT_VALUE_TYPES>(),
  order: yup.string(),
  page: yup.number(),
  filters: yup.array(
    yup.object({ category_id: yup.number(), search_filter_id: yup.number() }),
  ),
  is_no_addition: yup.boolean(),
  patient_id: yup.number(),
});

export type SearchStationDetailType = InferType<
  typeof SearchStationDetailSchema
>;
export const SearchStationDetailResolver = yupResolver(
  SearchStationDetailSchema,
);
